import { createSlice } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const initialState = {
  callingModalOpen: true,
  currentSidebarType: 'main',
  loginUserType: null,
  timezone: process.env.REACT_APP_TIMEZONE || 'Asia/Kolkata'
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCallingModalOpen(state, action) {
      state.callingModalOpen = action.payload;
    },
    setTimezone: (state, action) => {
      state.timezone = action.payload;
    },
    setSidebarType(state, action) {
      state.currentSidebarType = action.payload;
    },
    setLoginUserType(state, action) {
      state.loginUserType = action.payload;
    },
    clearCommonSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default commonSlice.reducer;
export const {
  clearCommonSlice,
  setCallingModalOpen,
  setSidebarType,
  setLoginUserType,
  setTimezone
} = commonSlice.actions;

export const selectCallingModal = (state) => state.common.callingModalOpen;
export const useCallingModal = () => {
  const callingModalOpen = useSelector(selectCallingModal);
  return useMemo(() => callingModalOpen, [callingModalOpen]);
};

export const selectCurrentSidebarType = (state) => state.common.currentSidebarType;
export const useCurrentSidebarType = () => {
  const currentSidebarType = useSelector(selectCurrentSidebarType);
  return useMemo(() => currentSidebarType, [currentSidebarType]);
};

export const selectLoginUserType = (state) => state.common.loginUserType;
export const useLoginUserType = () => {
  const loginUserType = useSelector(selectLoginUserType);
  return useMemo(() => loginUserType, [loginUserType]);
};

export const selectTimezone = (state) => state.common.timezone;
export const useTimezone = () => {
  const timezone = useSelector(selectTimezone);
  return useMemo(() => timezone, [timezone]);
};
